import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BsFillDatabaseFill } from "react-icons/bs";

const Sidebar = ({ isExpanded, isExpandedMob }) => {
  const { pathname } = useLocation();
  const data = [
    { title: "Status", link: "status" },
    { title: "Programs", link: "programs" },
    { title: "Program Category", link: "program-category" },
    { title: "Permission", link: "permission" },
    { title: "Roles", link: "role" },
    { title: "Roles and Permissions", link: "role-permission" },
    { title: "Email Vendors", link: "email-vendor" },
    { title: "Skills", link: "skill" },
    { title: "Standards", link: "standard" },
    { title: "Country", link: "country" },
    { title: "State", link: "state" },
    { title: "City", link: "city" },
    { title: "College", link: "college" },
    { title: "Course", link: "course" },
    { title: "School", link: "school" },
    { title: "Board", link: "board" },
    { title: "Books", link: "book" },
    { title: "Activity", link: "activity" },
    { title: "Companies", link: "company" },
    { title: "Users", link: "user" },
    { title: "To-Do", link: "todo" },
    { title: "Department", link: "career" },
    { title: "Career", link: "career-list" },
    { title: "Intakes", link: "intake" },
    { title: "Calendar System", link: "calendar-system" },
    { title: "College Rankings", link: "college-ranking" },
    { title: "College Scholarships", link: "college-scholarship" },
    { title: "College And Course", link: "college-course" },
    { title: "Exams", link: "exam" },
    { title: "College Exams", link: "college-exam" },
    { title: "Students", link: "students" },
    { title: "Quizzes", link: "quizzes" },
    { title: "Questions", link: "questions" },
    { title: "Products", link: "products" },
    { title: "Leveld", link: "level" },
    { title: "Scholarships Mapping", link: "scholarships-mapping" },
    { title: "Exam Mapping", link: "exam-mapping" },
    { title: "Scholarships", link: "scholarships" },
    { title: "Currency", link: "currency" },
  ];

  //sort on the basis of title start
  data.sort((a, b) => {
    let fa = a.title.toLowerCase(),
      fb = b.title.toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });
  //sort on the basis of title end

  return (
    <>
      <div className={`sidebar ${isExpandedMob ? `slide-nav` : ""} ${isExpanded ? "collapse-sidebar" : ""}`} id="sidebar">
        <div className="sidebar-inner">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              {data?.map((obj) => {
                return (
                  <li>
                    <Link className={pathname === `/${obj?.link}` && "active"} to={`/${obj?.link}`} >
                      <BsFillDatabaseFill /> <span>{obj?.title}</span>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      {isExpandedMob && (
        <div className={`sidebar-overlay ${isExpandedMob ? "opened" : ""}`} />
      )}
    </>
  );
};

export default Sidebar;
